import React from 'react';
import {ulrs} from './Constants';

const parseMortgagerates = (data, pageType) => 
{
    let assumptionsList = '';
    let disclaimers = '';
    const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const now = new Date();
    const apiDate = data?.lastCheckedAt ? new Date(data.lastCheckedAt) : null;

    let lastCheckedFormat = '';
    if (apiDate)
    {
        const displayDate = apiDate > now ? now : apiDate;
        lastCheckedFormat = displayDate.toLocaleString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZone: userTZ,
        });
    }

    const disclaimer = data?.lastCheckedAt && `These rates are current as of ${lastCheckedFormat}`;
    const tableHeaders = pageType === 'mortgagepage' ? ['Loan Option', 'Rate/APR'] :  ['Loan Option', 'Rate', 'APR'];
    const tableData = [];

    const tableContent = (element) => 
        pageType === 'mortgagepage' ? [<span> {element.rate}% / {element.apr}% </span>] : [<span> {element.rate}% </span>, <span>{element.apr}%</span>];

    if (data) 
    {
        const { productRates, assumptions } = data;
        
        if (productRates?.length) 
        {
            productRates.forEach(element => 
            {
                tableData.push([
                    <a href={ulrs[element.metadata.productCode]}>{element.metadata.description} *</a>,
                    ...tableContent(element),
                ])
    
                disclaimers += `<div _ngcontent-lrt-c91>${element?.metadata?.disclaimers[0]}</div>`;
            });
        }

        if (assumptions?.length) 
        {
            assumptionsList = assumptions.map(e => `<li>${e}</li>`).join("");
        }
    }
    
    return {
        tableHeaders, 
        tableData,
        lastCheckedFormat,
        disclaimer, 
        isStripesColors: true,
        assumptions: `
        <div _ngcontent-lrt-c89="" class="toggleContent" id="mortgage-rate-disclosure-container">
            ${disclaimers}
        </div>
        <p _ngcontent-lrt-c91="" class="assumptionsTitle">Assumptions</p>
        <div _ngcontent-lrt-c91="" class="assumptions">
            <ul _ngcontent-lrt-c91="">${assumptionsList}<ul>
        </div>`,
        productDisclaimers: `
        <div _ngcontent-lrt-c89="" class="toggleContent" id="mortgage-rate-disclosure-container">
            ${disclaimers}
        </div>
        `,
        assumptionsList:`
        <p _ngcontent-lrt-c91="" class="assumptionsTitle">Assumptions</p>
        <div _ngcontent-lrt-c91="" class="assumptions">
            <ul _ngcontent-lrt-c91="">${assumptionsList}<ul>
        </div>`
    };
}

export default parseMortgagerates;
